<nb-card size="large" [nbSpinner]="sharedService.load">
  <nb-card-body *ngIf="dataSource?.length">
    <div cdkDropList class="example-list" (cdkDropListDropped)="drop($event)">
      <div class="example-box" *ngFor="let user of dataSource" cdkDrag>
        <app-avatar [user]="user"></app-avatar>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer *ngIf="dataSource?.length">
    <button nbButton (click)="onOk()" status="success"><nb-icon icon="checkmark-outline"></nb-icon>OK</button>
    <button nbButton class="right-button" (click)="onCancel()" status="basic">
      <nb-icon icon="close-outline"></nb-icon>CANCEL
    </button>
  </nb-card-footer>
  <h6 *ngIf="dataSource && dataSource.length == 0">No user available.</h6>
</nb-card>
